<template>
  <div>
    <div v-for="song in songs" v-bind:key="song.id" id="song">
      <div class="row">
        <div class="songTitle col-12">
          <h2 v-html="song.songTitle"/>
        </div>
      </div>
      <div class="row">
        <div class="col-5">
          <Pickup :recordImage="song.recordImage" :pickup-size=song.pickupSize :audioFile="song.audioFile" :record-length=song.recordLength></Pickup>
        </div>
        <div class="col-7 songText">
          <p v-html="song.songText"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pickup from './Pickup.vue'

export default {
  name: 'Songs',
  components: {
    Pickup
  },
  data: function (){
    return {
      songs: [
        {
          id : 1,
          songTitle: "no fear",
          recordImage : "./frail-assets/no fear.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/01_no_fear.mp3",
          recordLength: 260,
          songText: "I know you're here<br />" +
              "You gave it all up for me<br />" +
              "There is no fear<br />" +
              "I'm filled with love you see<br/>" +
              "<br/>" +
              "Of all misunderstandings<br/>" +
              "You are the most misunderstood"
        },
        {
          id : 2,
          songTitle: "alright",
          recordImage : "./frail-assets/alright.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/02_alright.mp3",
          recordLength: 300,
          songText: "That's alright<br />" +
              "You're calling out for more<br />" +
              "Knockin' on my heart's door<br />" +
              "That's alright<br/>" +
              "<br/>" +
              "Footsteps on the stairway<br/>" +
              "A shadow in the hallway<br/>" +
              "That's alright<br/>" +
              "<br />" +
              "Hearing your voice is a definite choice<br />" +
              "You are impossibly waiting<br/>" +
              "I came to know that you never let go<br/>" +
              "You are impossibly staying<br/>" +
              "<br />" +
              "That's alright<br/>" +
              "Your footprints in my chambers<br/>" +
              "Your presence like a flame<br/>" +
              "That’s alright<br/>" +
              "<br/>" +
              "Choosing your light is a hell of a fight<br/>" +
              "You are impossibly radiant<br/>" +
              "I take off my cover I want You my lover<br/>" +
              "But I'm so impossibly naked"
        },
        {
          id : 3,
          songTitle: "deliver us",
          recordImage : "./frail-assets/deliver us.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/03_deliver_us.mp3",
          recordLength: 170,
          songText: "In ugliness we stand<br />" +
              "Obeying your commands<br />" +
              "Can we forgive like you forgive?<br />" +
              "Can we?<br/>" +
              "<br/>" +
              "In silence hear us say<br/>" +
              "The words you taught to pray<br/>" +
              "Won't You forgive like we forgive?<br/>" +
              "Won't you<br/>" +
              "<br />" +
              "Deliver us from evil"
        },
        {
          id : 4,
          songTitle: "frail",
          recordImage : "./frail-assets/frail.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/04_frail.mp3",
          recordLength: 319,
          songText: "What can | say, how can I prophesy?<br/>" +
              "Speaking comfort in accomplished times<br/>" +
              "A highway to You<br/>" +
              "What can I say, just look at Your finger tips<br/>" +
              "Holding the entire universe in your hand<br/>" +
              "A highway to You<br />" +
              "<br/>" +
              "Frail as grass that withers when You’re breathing<br/>" +
              "Frail as grass, my flower fades one day<br/>" +
              "Frail as grass, I may not be here tomorrow<br/>" +
              "But You hold me against your breast<br />" +
              "<br />" +
              "What can I do, I have to wait on you<br/>" +
              "Consider the one who numbers the stars<br/>" +
              "Believe in the goodness of Your piercing eyes<br/>" +
              "And wait for the wind that lifts me, lifts me<br/>" +
              "<br/>" +
              "I climb the mountain<br/>" +
              "I won’t be afraid<br/>" +
              "I'll tell the poets around me<br/>" +
              "Look: here is your God"
        },
        {
          id : 5,
          songTitle: "hide and seek",
          recordImage : "./frail-assets/hide and seek.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/05_hide_and_seek.mp3",
          recordLength: 317,
          songText: "Hide and seek<br/>" +
              "You play hide and seek<br/>" +
              "You want me closer<br/>" +
              "You want me near you<br/>" +
              "You know I can't say no no more<br/>" +
              "<br/>" +
              "Hide and seek<br/>" +
              "You play hide and seek<br/>" +
              "Now You are with me, near me<br/>" +
              "To be disappearing again<br/>" +
              "You know I can't say no no more<br/>" +
              "<br/>" +
              "You lead me in your forest<br/>" +
              "You take my hand on the ice shelves<br/>" +
              "And you call me again<br />" +
              "<br />" +
              "You know I can't say no no<br/>" +
              "You know I can't say no to you at all<br/>" +
              "You wouldn't take me serious<br/>" +
              "Yes that's the state I'm in <br/>" +
              "And you see I can't say I need you no more <br/>" +
              "You wouldn't believe me<br/>" +
              "<br/>" +
              "So You lead me in your forest<br/>" +
              "You take my hand on the ice shelves<br/>" +
              "And you call me again"
        },
        {
          id : 6,
          songTitle: "my heart for you",
          recordImage : "./frail-assets/my heart for you.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/06_my_heart_for_you.mp3",
          recordLength: 232,
          songText: "Mark the milestones of you mercy<br/>" +
              "Here's the tension, the turmoil of my soul<br/>" +
              "Here's my heart for you<br/>" +
              "This is my heart for you<br/>" +
              "<br/>" +
              "Keep my eyes open all of my days<br/>" +
              "Let your truth shine<br/>" +
              "Teach me your ways<br/>" +
              "Here's my heart for you<br/>" +
              "This is my heart for you<br/>" +
              "<br/>" +
              "No one, no one will wait in vain<br/>" +
              "No one waiting for you will be ashamed no<br/>" +
              "I will keep waiting more<br/>" +
              "Lover you are before me<br />" +
              "<br />" +
              "Notice all the goodness you got<br/>" +
              "Forgive all my mistakes of the past<br/>" +
              "Here's my heart for you<br/>" +
              "This is my heart for you"
        },
        {
          id : 7,
          songTitle: "words grow stale",
          recordImage : "./frail-assets/words grow stale.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/07_words_grow_stale.mp3",
          recordLength: 227,
          songText: "Look at my hands I got touch<br/>" +
              "I can freely wave them<br/>" +
              "Into the cloud I got air<br/>" +
              "I can slowly breathe it<br/>" +
              "You gave me feet to run<br/>" +
              "You gave me you to hang on to<br/>" +
              "As words grow stale<br/>" +
              "<br/>" +
              "Dying in church give me your truth<br/>" +
              "Will I freely enter<br/>" +
              "Into your courts at your throne?<br/>" +
              "Gently I remember<br/>" +
              "You make your home in me<br/>" +
              "Granting loveliness for free<br />" +
              "As words grow stale<br/>" +
              "<br/>" +
              "Mark the echo, let there be light<br/>" +
              "Words of old yet so alive<br/>" +
              "Mark the echo, word so divine<br/>" +
              "Let it shine"
        },
        {
          id : 8,
          songTitle: "miracles",
          recordImage : "./frail-assets/miracles.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/08_miracles.mp3",
          recordLength: 308,
          songText: "There were times<br/>" +
              "You were not there<br/>" +
              "Talking to an empty chair<br/>" +
              "Times you were not there<br/>" +
              "Praying to an empty chair<br/>" +
              "<br/>" +
              "World of wonders<br/>" +
              "<br/>" +
              "Miracles in secret<br/>"
        },
        {
          id : 9,
          songTitle: "the love within",
          recordImage : "./frail-assets/the love within.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/09_the_love_within.mp3",
          recordLength: 348,
          songText: "Mine is a song to sing<br/>" +
              "Yours the rhythm within<br/>" +
              "Mine is the body pulses perceiving<br/>" +
              "believing the spirit man’s wired for receiving<br/>" +
              "Mine is a song to sing<br/>" +
              "Yours the rhythm within<br/>" +
              " <br/>" +
              "Yours is a name to conceal<br/>" +
              "Mine is the son to reveal<br/>" +
              "Mine the reflection of beauty transcending<br/>" +
              "Yours the heart of a love neverending<br/>" +
              "Mine’s the son to receive<br/>" +
              "Yours the power to believe<br/>" +
              " <br/>" +
              "Mine are the fears to fear<br/>" +
              "Yours are the ears to hear<br/>" +
              "Mine the delusive deluge intruding<br/>" +
              "Collective illusions of comfort besides you<br/>" +
              "Mine are the sins to sin<br/>" +
              "Yours is the love within<br/>" +
              " <br/>" +
              "Yours is the joy of life<br/>" +
              "Mine is the gift to thrive<br/>" +
              "Yours never ending inventive creations<br/>" +
              "Transcending humanities imaginations<br/>" +
              "Yours is the joy of life<br/>" +
              "Mine is the gift to thrive<br/>" +
              " <br/>" +
              "Mine is a song to sing<br/>" +
              "Yours the rhythm within<br/>" +
              "Mine is the final breath to awaken<br/>" +
              "Into your arms when this vessel is breaking<br/>" +
              "Mine is a glorious thing<br/>" +
              "You are the love within"
        },
        {
          id : 10,
          songTitle: "find me",
          recordImage : "./frail-assets/find me.png",
          pickupSize : 0.25,
          audioFile: "./frail-assets/10_find_me.mp3",
          recordLength: 286,
          songText: "Keep my heart humble radiant for you<br/>" +
              "Keep my love burning with passion for you<br/>" +
              "Keep my mind simple focussed and true<br/>" +
              "<br/>" +
              "Find me in you<br/>" +
              "<br/>" +
              "Keep my eyes curious looking for life<br/>" +
              "Keep my ears sensitive for your whispers<br/>" +
              "Keep my hands open whatever you do<br/>" +
              "<br/>" +
              "Find me in you<br/>" +
              "<br/>" +
              "May the pain cleanse me polish my soul<br/>" +
              "May the night teach me you hear when I'm calling<br/>" +
              "May my tears rise like incense to you<br/>" +
              "<br/>" +
              "Find me in you<br/>" +
              "<br/>" +
              "May your smile guide me your laughter be felt<br/>" +
              "May your faith uncover the hope that is hidden<br/>" +
              "May you strike gold<br/>" +
              "When my life is through<br/>" +
              "<br/>" +
              "Find me in you"
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .songTitle {
    margin: auto;
    text-align: center;
    width: 100vw;
  }

  .songText {
    padding: 10px;
    margin: auto;
    text-align: center;
  }

  .row::after {
    content: "";
    clear: both;
    display: table;
  }

  [class*="col-"] {
    float: left;
    padding: 15px;
  }

  /* For mobile phones: */
  [class*="col-"] {
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    /* For desktop: */
    .col-1 {width: 8.33%;}
    .col-2 {width: 16.66%;}
    .col-3 {width: 25%;}
    .col-4 {width: 33.33%;}
    .col-5 {width: 41.66%;}
    .col-6 {width: 50%;}
    .col-7 {width: 58.33%;}
    .col-8 {width: 66.66%;}
    .col-9 {width: 75%;}
    .col-10 {width: 83.33%;}
    .col-11 {width: 91.66%;}
    .col-12 {width: 100%;}
  }

</style>
